module.exports = __webpack_public_path__ + "static/media/como-buscar.17a54aa4.png";